/**
 * Shared reveal engine: arms the root (.bq-armed), then sets .is-inview on
 * intersection. Sections keep their own data-*-reveal attributes and delays
 * (--i); shared keyframes live in bq-motion (bq-rise, bq-stamp-soft).
 */
(function () {
  'use strict';
  var bq = window.bq;
  if (!bq || window.bqReveal) return;
  window.bqReveal = function (root, selector) {
    if (!root) return;
    if (bq.reducedMotion() || !('IntersectionObserver' in window)) return;
    root.classList.add('bq-armed');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-inview');
        io.unobserve(en.target);
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });
    root.querySelectorAll(selector).forEach(function (el) { io.observe(el); });
  };
})();
